import EdJsonViewer from './src/EdJsonViewer.vue'

/* istanbul ignore next */
EdJsonViewer.install = function (Vue) {
  Vue.component(EdJsonViewer.name, EdJsonViewer)
}

export default EdJsonViewer;
